import {
  ChangeDetectionStrategy,
  Component,
  Input,
  booleanAttribute,
} from '@angular/core';

export type DsListShadow = 'none' | 'l1' | 'l2' | 'l3';

@Component({
  selector: 'ds-list',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div [class]="hostClasses">
      <ng-content select="ds-item-list" />
    </div>
  `,
  styles: [`
    :host {
      display: block;
      min-width: 0;
    }

    .ds-list {
      display: flex;
      flex-direction: column;
      gap: var(--ds-list-gap);
      width: 100%;
      min-width: 0;
      box-sizing: border-box;
      background: var(--ds-list-background);
    }

    .ds-list--bordered {
      border: var(--ds-list-border-width) solid var(--ds-list-border-color);
    }

    .ds-list--borderless {
      border: 0;
    }

    .ds-list--rounded {
      border-radius: var(--ds-list-border-radius);
    }

    .ds-list--rounded.ds-list--bordered {
      overflow: hidden;
    }

    .ds-list--rounded.ds-list--borderless {
      overflow: visible;
    }

    .ds-list--square {
      border-radius: 0;
    }

    .ds-list--shadow-none {
      box-shadow: none;
    }

    .ds-list--shadow-l1 {
      box-shadow: var(--ds-list-shadow-l1);
    }

    .ds-list--shadow-l2 {
      box-shadow: var(--ds-list-shadow-l2);
    }

    .ds-list--shadow-l3 {
      box-shadow: var(--ds-list-shadow-l3);
    }
  `],
})
export class DsListComponent {
  @Input({ transform: booleanAttribute }) border = true;
  @Input() shadow: DsListShadow = 'none';
  @Input({ transform: booleanAttribute }) borderRadius = true;

  get hostClasses(): string {
    return [
      'ds-list',
      this.border ? 'ds-list--bordered' : 'ds-list--borderless',
      this.borderRadius ? 'ds-list--rounded' : 'ds-list--square',
      `ds-list--shadow-${this.shadow}`,
    ].join(' ');
  }
}
